import { react, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import { useSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import TokenService from '../services/TokenService';

const ContactUs = () => {
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [contactMessage, setContactMessage] = useState('');
    const [sendingMessage, setSendingMessage] = useState(false);
    const [messageSent, setMessageSent] = useState(false);
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });

    function isValidated() {

        let isValid = true;
        let errors = [];

        if (contactMessage.trim() == '') {
            errors["contactMessage"] = "Missing your Message";
            isValid = false;
        }

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndSend() {
        let validation = isValidated();

        if (validation.isValid) {

            setFormValidation(validation);

            // post to server

            var postData = {
                message: contactMessage,
            }
            setSendingMessage(true);
            TokenService.post(postData, 'Returner_ContactMessage', '')
                .then((response) => {
                    if (response !== null) {
                        setSendingMessage(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            setMessageSent(true);
                        }
                        else {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                    
                    
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    if (response !== null) {
                        setSendingMessage(false);
                    }
                });


        }
        else {
            setFormValidation(validation);
        }
    }

    let panel = null;
    if (messageSent) {
        panel = <div style={{marginTop:'50px'} } >Thank you for your message<br />We will respond to you as soon as possible.</div>;
        
    }
    else {

        panel =
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '10px' }}>
                <div>
                    <div style={{ color: 'var(--sipzee-grey)', fontSize: '18pt', fontWeight: 'bold' }}>
                        Have a question or comment?
                    </div>

                    <div style={{
                        marginTop: '15px', fontSize: '14pt', display: 'flex', flexDirection: 'column'
                    }}>
                        Send us a note:
                    </div>

                    <div>
                        <form>
                            <div style={{ marginTop: '15px' }}>
                                <TextField multiline rows={4} style={{ width: '300px' }} error={formValidation.errors['contactMessage'] !== undefined} label="Message" onChange={(e) => setContactMessage(e.target.value)} value={contactMessage} variant="outlined" />
                                <div className='FormFieldErrorDescription'> {formValidation.errors['contactMessage'] !== undefined ? formValidation.errors['contactMessage'] : ''}</div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                <div className='FormFieldErrorDescription'> {formValidation.errors['token'] !== undefined ? formValidation.errors['token'] : ''}</div>
                            </div>


                            <LoadingButton loading={sendingMessage} loadingIndicator="Sending" style={{ marginTop: '15px' }} variant="contained" color="sipzeeGreen" onClick={() => validateAndSend()}>Send</LoadingButton >
                        </form>
                    </div>
                </div>
            </div>
    }

    return panel;
}

export default ContactUs;